export const workCreditGroupFragment = `
    folderGroup {
        folder {
            person {
                name
                surname
            }
        }
        group {
            id
            name
            color
        }
    }
`;

export const creditOffersFrag = `
    groupId
    offerId
    creditPrice
`;

export const workCreditPaymentsFragment = `
    folderId
    dateFrom
    payments {
        id
        workOfferId
        offerId
        applications
        groupId
        amount
        releasableAmount
    }
`;
